define('lib/zeroBasedDay',[], function() {
  return new Date().getDay() - 1;
});

